<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="{{ modalId }}">Add Event</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <div class="input-group mb-3">
                <input [(ngModel)]="event.name" type="text" class="form-control" placeholder="Event Name" aria-label="Event name">
            </div>
            <app-date-time-picker [(timestamp)]="event.scheduledTime"></app-date-time-picker>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" [disabled]="event.name?.trim() =='' || !event.name || !event.scheduledTime" (click)="add()">Save</button>
    </div>
</ng-template>

<button *ngIf="user" class="btn btn-outline-primary" (click)="open(content)">Create New Event</button>